import React, { useEffect, useState } from 'react'
import { Dimmer, Form, Icon, Sidebar, SidebarProps } from 'semantic-ui-react'
import LoaderMilkCan from '../Loader'
import Box from '../Box'
import { DrawerEl } from './style'
import { ESCAPE_KEY_CODE_VALUE } from '~/Constants'
import { CSSProperties } from 'styled-components'

interface DrawerProps extends SidebarProps {
  isBusy?: boolean
  handleSubmit?: any
  header: string
  top?: number;
  content: React.ReactNode
  isVisible: boolean
  closeOnEscape?: boolean
  minWidth?: CSSProperties['minWidth']
}

const Drawer: React.FC<DrawerProps> = (props) => {
  const [top, setTop] = useState(window.scrollY - 113 > 0 ? window.screenY : 0)
  const { onHide, handleSubmit, isVisible, isBusy, closeOnEscape, onHidden, minWidth } = props

  useEffect(() => {
    setTop(window.scrollY - 113 > 0 ? window.scrollY - 113 : 0)
    const handleScroll = () => {
      if (isVisible) {
        if (window.scrollY > 113) {
          setTop(window.scrollY - 113)
        } else {
          setTop(0)
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && closeOnEscape) {
      document.addEventListener('keydown', handleKeyPress)
    }
    return () => document.removeEventListener('keydown', handleKeyPress)
  }, [isVisible])

  function handleKeyPress(e) {
    if (e.keyCode === ESCAPE_KEY_CODE_VALUE) {
      if (onHide) {
        onHide(e, null)
      } else if (onHidden) {
        onHidden(e, null)
      }
    }
  }

  function renderHeader() {
    return <DrawerEl.DrawerHeader>
      <DrawerEl.DrawerTitle>
        {props.header}
      </DrawerEl.DrawerTitle>
      <DrawerEl.DrawerAction>
        {(onHide || onHidden) && <DrawerEl.DrawerActionClose
          compact
          icon
          size='large'
          type='button'
          onClick={(e, data) => {
            if (onHide) {
              onHide(e, data)
            } else if (onHidden) {
              onHidden(e, data)
            }
          }}
        >
          <Icon size='large' name='times circle outline'></Icon>
        </DrawerEl.DrawerActionClose>
        }
      </DrawerEl.DrawerAction>
    </DrawerEl.DrawerHeader>
  }

  return <DrawerEl.DrawerContainer $minWidth={minWidth}>
    <Sidebar
      className='drawer'
      animation='push'
      as={handleSubmit ? Form : 'div'}
      style={{
        top: top,
        height: top > 0 ? '100vh' : 'calc(100vh - 113px)',
        maxHeight: '100vh'
      }}
      direction='right'
      visible={isVisible}
      onSubmit={handleSubmit}
      width='very wide'
    >
      <Dimmer active={isBusy} inverted>
        <LoaderMilkCan isLoading={isBusy} />
      </Dimmer>
      <Box header={renderHeader()} fluid content={props.content}></Box>
    </Sidebar>
  </DrawerEl.DrawerContainer>
}
export default Drawer